export default "__VITE_ASSET__DUn6vv_2__"